// Model
import ShippingTypeModel from "../model/shipping-type.model";

export function mapperToShippingTypeModel(shippingTypeDTO) {
    return new ShippingTypeModel(shippingTypeDTO.id, shippingTypeDTO.name)
}